import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  radicationText, getTermsAndConditions, getDataTreatment, structureForm, countries, states,
  towns, consultParametrizableDataQueryFiles, saveFilesApi, getDocumentDataApi, typesIdentification,
  certificateUses
} from './structureClientFormAPI';

const initialState = {
  statusRadicationText: "idle",
  radicationText: '',

  statusTermsAndConditions: "idle",
  termsAndConditions: '',

  statusDataTreatment: "idle",
  dataTreatment: '',

  statusStructureForm: "idle",
  structureForm: '',

  statusChangeStructure: "idle",

  statusCountries: "idle",
  countries: {data: []},

  statusStates: "idle",
  states: {data: []},

  statusTowns: "idle",
  towns: {data: []},

  statusTypesID: "idle",
  typesID: '',

  statusUses: "idle",
  uses: '',

  statusParametrizableDataQuery: "idle",
  parametrizableDataQuery: '',

  statusRegisterRequest: "idle",
  registerRequest: '',

  statusGetDocumentData: "idle",
  getDocumentData: '',
};

export const dataRadicationText = createAsyncThunk(
  '/structureClientForm/radication-text',
  async (data) => {
    const response = await radicationText(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const dataTermsAndConditions = createAsyncThunk(
  '/structureClientForm/terms-and-conditions',
  async (data) => {
    const response = await getTermsAndConditions(data);
    if (response.status === 'error') throw ({message: response.data.message})
    return response;
  }
);

export const dataDataTreatment = createAsyncThunk(
  '/structureClientForm/data-treatment',
  async (data) => {
    const response = await getDataTreatment(data);
    if (response.status === 'error') throw ({message: response.data.message})
    return response;
  }
);

export const dataStructureForm = createAsyncThunk(
  '/structureClientForm/structure-form',
  async (data) => {
    const response = await structureForm(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const countriesData = createAsyncThunk(
  '/structureClientForm/countries',
  async (data) => {
    const response = await countries(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const statesData = createAsyncThunk(
  '/structureClientForm/states',
  async (data) => {
    const response = await states(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const changeStructureForm = createAsyncThunk(
  '/structureClientForm/changeStructureForm',
  async (data) => {
    return data;
  }
);

export const townsData = createAsyncThunk(
  '/structureClientForm/towns',
  async (data) => {
    const response = await towns(data);
    if (response.status == 'error') throw ({ message: response.data.message })
    return response;
  }
);

export const typesIDData = createAsyncThunk(
  '/structureClientForm/typesID',
  async (data) => {
    const response = await typesIdentification(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const certificateUseData = createAsyncThunk(
  '/structureClientForm/certificateUses',
  async (data) => {
    const response = await certificateUses(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const getParametrizableDataQueryFiles = createAsyncThunk(
  '/structureClientForm/getParametrizableDataQueryFiles',
  async (data) => {
    const response = await consultParametrizableDataQueryFiles(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const saveFiles = createAsyncThunk(
  '/structureClientForm/saveFiles',
  async (data) => {
    const response = await saveFilesApi(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const getDocumentDataConsult = createAsyncThunk(
  '/structureClientForm/getDocumentData',
  async (data) => {
    const response = await getDocumentDataApi(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const structureClientFormSlice = createSlice({
  name: 'structureClientForm',
  initialState,
  reducers: {
    reset: () => initialState,
    clearValuesSaveFiles: (state) => {
      state.statusRegisterRequest = "idle";
      state.registerRequest = '';
      state.statusGetDocumentData = "idle";
      state.getDocumentData = '';
    },
    clearTowns: (state) => {
      state.towns = {...state.towns, data:[]};
    },
    clearStates: (state) => {
      state.states = {...state.states, data:[]};
      state.towns = {...state.towns, data:[]};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(dataRadicationText.pending, (state) => {
        state.statusRadicationText = 'loading';
      })
      .addCase(dataRadicationText.fulfilled, (state, action) => {
        state.statusRadicationText = 'fulfilled';
        state.radicationText = action.payload.text;
      })
      .addCase(dataRadicationText.rejected, (state) => {
        state.statusRadicationText = 'rejected';
      })
      //#region RTK dataTermsAndConditions
      .addCase(dataTermsAndConditions.pending, (state) => {
        state.statusTermsAndConditions = 'loading';
      })
      .addCase(dataTermsAndConditions.fulfilled, (state, action) => {
        state.statusTermsAndConditions = 'fulfilled';
        state.termsAndConditions = action.payload;
      })
      .addCase(dataTermsAndConditions.rejected, (state) => {
        state.statusTermsAndConditions = 'rejected';
      })
      //#endregion
      //#region RTK dataDataTreatment
      .addCase(dataDataTreatment.pending, (state) => {
        state.statusDataTreatment = 'loading';
      })
      .addCase(dataDataTreatment.fulfilled, (state, action) => {
        state.statusDataTreatment = 'fulfilled';
        state.dataTreatment = action.payload;
      })
      .addCase(dataDataTreatment.rejected, (state) => {
        state.statusDataTreatment = 'rejected';
      })
      //#endregion
      //#region RTK dataStructureForm
      .addCase(dataStructureForm.pending, (state) => {
        state.statusStructureForm = 'loading';
      })
      .addCase(dataStructureForm.fulfilled, (state, action) => {
        state.statusStructureForm = 'fulfilled';
        state.structureForm = action.payload;
      })
      .addCase(dataStructureForm.rejected, (state) => {
        state.statusStructureForm = 'rejected';
      })
      .addCase(changeStructureForm.fulfilled, (state, action) => {
        state.structureForm = action.payload;
        state.statusChangeStructure = 'fulfilled';
      })
      //#endregion
      //#region RTK countriesData
      .addCase(countriesData.pending, (state) => {
        state.statusCountries = 'loading';
      })
      .addCase(countriesData.fulfilled, (state, action) => {
        state.statusCountries = 'fulfilled';
        state.countries = action.payload;
      })
      .addCase(countriesData.rejected, (state) => {
        state.statusCountries = 'rejected';
      })
      //#endregion
      //#region RTK statesData
      .addCase(statesData.pending, (state) => {
        state.statusStates = 'loading';
      })
      .addCase(statesData.fulfilled, (state, action) => {
        state.statusStates = 'fulfilled';
        state.states = action.payload;
      })
      .addCase(statesData.rejected, (state) => {
        state.statusStates = 'rejected';
      })
      //#endregion
      //#region RTK townsData
      .addCase(townsData.pending, (state) => {
        state.statusTowns = 'loading';
      })
      .addCase(townsData.fulfilled, (state, action) => {
        state.statusTowns = 'fulfilled';
        state.towns = action.payload;
      })
      .addCase(townsData.rejected, (state) => {
        state.statusTowns = 'rejected';
      })
      //#endregion 
      //#region RTK typesIDData
      .addCase(typesIDData.pending, (state) => {
        state.statusTypesID = 'loading';
      })
      .addCase(typesIDData.fulfilled, (state, action) => {
        state.statusTypesID = 'fulfilled';
        state.typesID = action.payload;
      })
      .addCase(typesIDData.rejected, (state) => {
        state.statusTypesID = 'rejected';
      })
      //#endregion    
      //#region RTK certificateUseData
      .addCase(certificateUseData.pending, (state) => {
        state.statusUses = 'loading';
      })
      .addCase(certificateUseData.fulfilled, (state, action) => {
        state.statusUses = 'fulfilled';
        state.uses = action.payload;
      })
      .addCase(certificateUseData.rejected, (state) => {
        state.statusUses = 'rejected';
      })
      //#endregion
      //#region RTK parametrizableDataQueryFiles
      .addCase(getParametrizableDataQueryFiles.pending, (state) => {
        state.statusParametrizableDataQuery = 'loading';
      })
      .addCase(getParametrizableDataQueryFiles.fulfilled, (state, action) => {
        state.statusParametrizableDataQuery = 'fulfilled';
        state.parametrizableDataQuery = action.payload;
      })
      .addCase(getParametrizableDataQueryFiles.rejected, (state) => {
        state.statusParametrizableDataQuery = 'rejected';
      })
      //#endregion
      //#region RTK registerRequest
      .addCase(saveFiles.pending, (state) => {
        state.statusRegisterRequest = 'loading';
      })
      .addCase(saveFiles.fulfilled, (state, action) => {
        state.statusRegisterRequest = 'fulfilled';
        state.registerRequest = action.payload;
      })
      .addCase(saveFiles.rejected, (state) => {
        state.statusRegisterRequest = 'rejected';
      })
      //#endregion
      //#region RTK documentData
      .addCase(getDocumentDataConsult.pending, (state) => {
        state.statusGetDocumentData = 'loading';
      })
      .addCase(getDocumentDataConsult.fulfilled, (state, action) => {
        state.statusGetDocumentData = 'fulfilled';
        state.getDocumentData = action.payload;
      })
      .addCase(getDocumentDataConsult.rejected, (state) => {
        state.statusGetDocumentData = 'rejected';
      })
    //#endregion
  },
});

export const { reset, clearValuesSaveFiles, clearStates, clearTowns } = structureClientFormSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectStatusRadicationText = (state) => state.structureClientForm.statusRadicationText;
export const selectRadicationText = (state) => state.structureClientForm.radicationText;

export const selectStatusTermsAndConditions = (state) => state.structureClientForm.statusTermsAndConditions;
export const selectTermsAndConditions = (state) => state.structureClientForm.termsAndConditions;

export const selectStatusDataTreatment = (state) => state.structureClientForm.statusDataTreatment;
export const selectDataTreatment = (state) => state.structureClientForm.dataTreatment;

export const selectStatusStructureForm = (state) => state.structureClientForm.statusStructureForm;
export const selectStructureForm = (state) => state.structureClientForm.structureForm;

export const selectStatusChangeStructure = (state) => state.structureClientForm.statusChangeStructure;

export const selectStatusCountries = (state) => state.structureClientForm.statusCountries;
export const selectCountries = (state) => state.structureClientForm.countries;

export const selectStatusStates = (state) => state.structureClientForm.statusStates;
export const selectStates = (state) => state.structureClientForm.states;

export const selectStatusTowns = (state) => state.structureClientForm.statusTowns;
export const selectTowns = (state) => state.structureClientForm.towns;

export const selectStatusTypesID = (state) => state.structureClientForm.statusTypesID;
export const selectTypesID = (state) => state.structureClientForm.typesID;

export const selectStatusCertificateUses = (state) => state.structureClientForm.statusUses;
export const selectCertificateUses = (state) => state.structureClientForm.uses;

export const selectStatusParametrizableDataQuery = (state) => state.structureClientForm.statusParametrizableDataQuery;
export const selectParametrizableDataQuery = (state) => state.structureClientForm.parametrizableDataQuery;

export const selectStatusRegisterRequest = (state) => state.structureClientForm.statusRegisterRequest;
export const selectRegisterRequest = (state) => state.structureClientForm.registerRequest;

export const selectStatusGetDocumentData = (state) => state.structureClientForm.statusGetDocumentData;
export const selectGetDocumentData = (state) => state.structureClientForm.getDocumentData;

export default structureClientFormSlice.reducer;